/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './RMDTableMobile.scss';

import React from 'react';

import {currency, lastBusinessDay} from "../../../utils/dashboard-utils";


const toggle = (e) => {
    try{
        var tbodyClasses = e.target.parentElement.parentElement.classList;
        if(tbodyClasses.contains("exp")){
            tbodyClasses.remove("exp");
        }else{
            tbodyClasses.add("exp");
        }
    }catch(err)
    {
        console.log("Error Expanding" ,err);
    }
    
};

const TableHeaderMobile = (props) => {
    if (props) {
        return (
            <thead>
                <tr className="columns ">
                    <th className="name">Your RMD Eligible Accounts</th>
                    <th className="year-rmd">{lastBusinessDay(props.currentRmdYear)} Ending</th>
                </tr>
                <tr className="totals">
                    <td className="name" onClick={(e) => toggle(e)} > Total Balance </td>
                    <td className="year-rmd account-balance">{props.totalBalance}</td>
                </tr>
                <tr>
                    <td className="expData">{lastBusinessDay(props.currentRmdYear)} Ending</td>
                    <td className="expData account-balance">{props.totalBalance}</td>
                </tr>
                <tr>
                    <td className="expData">{props.currentRmdYear} RMD</td>
                    <td className="expData year-rmd">{props.totalRMD}</td>
                </tr>
                { props.showYTDColumns ? (
                <tr>
                    <td className="expData">YTD Distributions</td>
                    <td className="expData distributions-ytd">{currency(props.rmdSummary.distributedAmountRMD)}</td>
                </tr>
                ):null}
                { props.showYTDColumns ? (
                <tr>
                    <td className="expData">Remaining for the year</td>
                    <td className="expData remaining-year">{currency(props.rmdSummary.totalRemainingYear)}</td>
                </tr>
                ):null}
                { props.showYTDColumns ? (
                <tr>
                    <td className="expData">YTD Tax Withholding</td>
                    <td className="expData tax-ytd">{currency(props.rmdSummary.totalTaxWithHoldings)}</td>
                </tr>
                ):null}
            </thead>
        );
    }
    return null;
};

export default TableHeaderMobile;